
// import {request,domain as dd} from '../utils/request'
//
// const tokenUrl = dd + '/dmz/qiniu/token'

import request from '../utils/request'

// const tokenUrl = host + '/dmz/qiniu/token'

// export const domain = 'http://p94f3cj0e.bkt.clouddn.com/'

const tokenUrl =   '/dmz/qiniu/token'

export const domain = 'http://img.youx365.com/'

export const getToken = () => {
  return request.get(tokenUrl)
}
